import React, { useMemo } from "react";
import DOMPurify from "dompurify";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

// Renders sanitised inbound-email HTML (with inline images / screenshots).
// Inline image srcs are stored server-side as relative /api/tickets/.../attachments/...
// paths; we prefix them with the backend origin so they resolve in production too.
export const EmailBody = ({ html, className = "" }) => {
  const clean = useMemo(() => {
    if (!html) return "";
    const withHost = html.replace(
      /(src\s*=\s*["'])\/api\/tickets\//gi,
      `$1${BACKEND_URL}/api/tickets/`
    );
    return DOMPurify.sanitize(withHost, {
      ALLOWED_TAGS: [
        "a", "b", "i", "u", "em", "strong", "p", "br", "div", "span", "ul", "ol",
        "li", "blockquote", "pre", "code", "img", "table", "thead", "tbody", "tr",
        "td", "th", "h1", "h2", "h3", "h4", "h5", "h6", "hr", "font", "small", "sub", "sup",
      ],
      ALLOWED_ATTR: ["href", "src", "alt", "title", "width", "height", "style", "target", "rel", "color", "align"],
      ALLOW_DATA_ATTR: false,
    });
  }, [html]);

  if (!clean) return null;
  return (
    <div
      data-testid="email-body-html"
      className={`email-body text-sm text-slate-700 break-words [&_img]:max-w-full [&_img]:h-auto [&_img]:rounded [&_img]:my-2 [&_a]:text-blue-600 [&_a]:underline [&_table]:border-collapse ${className}`}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
};

export default EmailBody;
